/**
 * Build-time feature switches.
 *
 * Creator self-signup ("Create your account" and the /signup page) is OFF
 * unless the uploader is built with `VITE_PUBLIC_SIGNUP_ENABLED=true`.
 * Creators join through their agency's invitation link
 * (/accept-invitation/:token), which is not affected. Hiding the page is
 * cosmetic: the backend refuses signup unless its own
 * `PUBLIC_SIGNUP_ENABLED=true` (backend/src/config/public-signup.ts).
 * Flip both halves together.
 */

/** Only an explicit "true" / "1" opens signup; anything else keeps it closed. */
export function parsePublicSignupFlag(raw: string | undefined): boolean {
  const value = (raw ?? '').trim().toLowerCase();
  return value === 'true' || value === '1';
}

/** Read at render time, so tests can switch it with `vi.stubEnv`. */
export function isPublicSignupEnabled(): boolean {
  return parsePublicSignupFlag(import.meta.env.VITE_PUBLIC_SIGNUP_ENABLED);
}

/**
 * Terms of Service and Privacy Policy live on the dashboard (one copy of the
 * text): VITE_CONTENT_UPLOADER_DEVICE_FARM_URL, defaulting to laxmiai.net.
 */
export function legalUrl(page: 'terms' | 'privacy'): string {
  const base = (import.meta.env.VITE_CONTENT_UPLOADER_DEVICE_FARM_URL ?? '').trim() || 'https://laxmiai.net';
  return `${base.replace(/\/+$/, '')}/${page}`;
}
